// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-group[data-v-6b76e90a]{display:flex;flex-direction:column;align-items:flex-start;height:100%;width:100%}.opt-btn[data-v-6b76e90a]{width:100%;height:33%}.opt-btn button[data-v-6b76e90a]{width:80px;height:100%}.demo-carousel[data-v-6b76e90a]{width:100%;height:700px;text-align:center;background-color:#bebec0}", ""]);
// Exports
module.exports = exports;
